export default __webpack_public_path__ + "media/images/contact-dog-hands-182d8d5229742c9c8c271231c13d9ff1.png";